<template>
  <section class="section-base form-section-base">
    <div class="form-section-base__controls">
      <v-row>
        <v-col>
          <v-checkbox
            v-model="isApplicant"
            :label="ApplicantRightholderText.LABEL"
            hide-details
          />
        </v-col>
      </v-row>
    </div>

    <v-container v-if="isApplicant">
      <div class="form-section-base__title">Подать заявление как:</div>

      <div class="form-section-base__controls">
        <v-row>
          <v-col>
            <v-radio-group v-model="fillType">
              <v-radio
                label="Заявитель или Представитель заявителя по нотариально заверенной доверенности в бумажном виде"
                :value="SubjectFillType.MANUAL"
              />
              <v-radio
                :label="SubjectFillTypeText.MACHINE"
                :value="SubjectFillType.MACHINE"
              />
            </v-radio-group>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-container>
      <Footer
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { Role } from '@/utils/dictionaries';
import { leaveStep } from '@/utils/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import { ServicesModule } from '@/store/modules/services';
import {
  ApplicantRightholderText,
  SubjectFillType,
  SubjectFillTypeText,
} from '@/constants';

export default {
  name: 'SelectApplicantRightholder',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
    roleType: {
      type: String,
      required: true,
    },
  },
  components: {
    Footer,
  },
  data() {
    return {
      StepDirection,
      StepName,
      leaveStep,
      Role,
      SubjectFillType,
      SubjectFillTypeText,
      fillType: SubjectFillType.MANUAL,
      invalidFields: [],
      isApplicant: false,
      ApplicantRightholderText,
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const applicantRightholder =
        ServicesModule.statement.subjects.applicantRightholder;

      if (applicantRightholder) {
        this.isApplicant = true;
        const fillType = applicantRightholder.uiContext?.fillType;

        if (fillType === SubjectFillType.MANUAL)
          this.fillType = SubjectFillType.MANUAL;
        if (fillType === SubjectFillType.MACHINE)
          this.fillType = SubjectFillType.MACHINE;
      }
    },
    touchFields() {},
    assemblyModel() {
      if (this.isApplicant) return this.fillType;

      return null;
    },
    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: StepName.S3,
      });
    },
  },
};
</script>
